module.exports = require('./lib/index')



//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/index.js
// module id = 1
// module chunks = 0